export enum NotificationPreferenceType {
    WORKPAPER_ASSIGNED_TO = 'WORKPAPER_ASSIGNED_TO',
    WORKPAPER_UNASSIGNED_FROM = 'WORKPAPER_UNASSIGNED_FROM',
    WORKPAPER_ASSIGNEES_ADDED = 'WORKPAPER_ASSIGNEES_ADDED',
    WORKPAPER_ASSIGNEES_REMOVED = 'WORKPAPER_ASSIGNEES_REMOVED',
    WORKPAPER_GUESTS_ADDED = 'WORKPAPER_GUESTS_ADDED',
    WORKPAPER_GUESTS_REMOVED = 'WORKPAPER_GUESTS_REMOVED',
    WORKPAPER_ACTIVE = 'WORKPAPER_ACTIVE',
    WORKPAPER_ARCHIVED = 'WORKPAPER_ARCHIVED',
    WORKPAPER_COMPLETED = 'WORKPAPER_COMPLETED',
    WORKPAPER_EXPORT_COMPLETED = 'WORKPAPER_EXPORT_COMPLETED',
    WORKPAPER_EXPORT_ERROR = 'WORKPAPER_EXPORT_ERROR',
    WORKSHEET_ASSIGNED_TO = 'WORKSHEET_ASSIGNED_TO',
    WORKSHEET_UNASSIGNED_FROM = 'WORKSHEET_UNASSIGNED_FROM',
    WORKSHEET_ASSIGNEES_ADDED = 'WORKSHEET_ASSIGNEES_ADDED',
    WORKSHEET_ASSIGNEES_REMOVED = 'WORKSHEET_ASSIGNEES_REMOVED',
    WORKSHEET_REVIEWED = 'WORKSHEET_REVIEWED',
    WORKSHEET_AWAITING_REVIEW = 'WORKSHEET_AWAITING_REVIEW',
    WORKSHEET_EXCLUDED = 'WORKSHEET_EXCLUDED',
    WORKSHEET_UNPREPARED = 'WORKSHEET_UNPREPARED',
    WORKSHEET_DELETED = 'WORKSHEET_DELETED',
    OTHER_SCHEDULE_ASSIGNED_TO = 'OTHER_SCHEDULE_ASSIGNED_TO',
    OTHER_SCHEDULE_UNASSIGNED_FROM = 'OTHER_SCHEDULE_UNASSIGNED_FROM',
    OTHER_SCHEDULE_ASSIGNEES_ADDED = 'OTHER_SCHEDULE_ASSIGNEES_ADDED',
    OTHER_SCHEDULE_ASSIGNEES_REMOVED = 'OTHER_SCHEDULE_ASSIGNEES_REMOVED',
    OTHER_SCHEDULE_REVIEWED = 'OTHER_SCHEDULE_REVIEWED',
    OTHER_SCHEDULE_AWAITING_REVIEW = 'OTHER_SCHEDULE_AWAITING_REVIEW',
    OTHER_SCHEDULE_ARCHIVED = 'OTHER_SCHEDULE_ARCHIVED',
    COMMENT_TAGGED = 'COMMENT_TAGGED',
    COMMENT_REPLIED = 'COMMENT_REPLIED',
    COMMENT_ACTIVE = 'COMMENT_ACTIVE',
    COMMENT_RESOLVED = 'COMMENT_RESOLVED',
    QUERY_REPLIED = 'QUERY_REPLIED',
    QUERY_ACTIVE = 'QUERY_ACTIVE',
    QUERY_RESOLVED = 'QUERY_RESOLVED',
    QUERY_TAGGED = 'QUERY_TAGGED',
    CERTIFICATION_REMOVED = 'CERTIFICATION_REMOVED',
    CERTIFICATION_STATUS_CHANGE = 'CERTIFICATION_STATUS_CHANGE',
    CERTIFICATION_READY = 'CERTIFICATION_READY',
    CERTIFICATION_DONE = 'CERTIFICATION_DONE',
}

export enum NotificationType {
    WORKPAPER_ASSIGNED_TO = 'WORKPAPER_ASSIGNED_TO',
    WORKPAPER_UNASSIGNED_FROM = 'WORKPAPER_UNASSIGNED_FROM',
    WORKPAPER_ASSIGNEES_ADDED = 'WORKPAPER_ASSIGNEES_ADDED',
    WORKPAPER_ASSIGNEES_REMOVED = 'WORKPAPER_ASSIGNEES_REMOVED',
    WORKPAPER_GUESTS_ADDED = 'WORKPAPER_GUESTS_ADDED',
    WORKPAPER_GUESTS_REMOVED = 'WORKPAPER_GUESTS_REMOVED',
    WORKPAPER_ACTIVE = 'WORKPAPER_ACTIVE',
    WORKPAPER_ARCHIVED = 'WORKPAPER_ARCHIVED',
    WORKPAPER_COMPLETED = 'WORKPAPER_COMPLETED',
    WORKPAPER_EXPORT_COMPLETED = 'WORKPAPER_EXPORT_COMPLETED',
    WORKPAPER_EXPORT_ERROR = 'WORKPAPER_EXPORT_ERROR',
    WORKSHEET_CREATED = 'WORKSHEET_CREATED',
    WORKSHEET_ASSIGNED_TO = 'WORKSHEET_ASSIGNED_TO',
    WORKSHEET_UNASSIGNED_FROM = 'WORKSHEET_UNASSIGNED_FROM',
    WORKSHEET_ASSIGNEES_ADDED = 'WORKSHEET_ASSIGNEES_ADDED',
    WORKSHEET_ASSIGNEES_REMOVED = 'WORKSHEET_ASSIGNEES_REMOVED',
    WORKSHEET_REVIEWED = 'WORKSHEET_REVIEWED',
    WORKSHEET_AWAITING_REVIEW = 'WORKSHEET_AWAITING_REVIEW',
    WORKSHEET_EXCLUDED = 'WORKSHEET_EXCLUDED',
    WORKSHEET_UNPREPARED = 'WORKSHEET_UNPREPARED',
    WORKSHEET_DELETED = 'WORKSHEET_DELETED',
    OTHER_SCHEDULE_ASSIGNED_TO = 'OTHER_SCHEDULE_ASSIGNED_TO',
    OTHER_SCHEDULE_UNASSIGNED_FROM = 'OTHER_SCHEDULE_UNASSIGNED_FROM',
    OTHER_SCHEDULE_ASSIGNEES_ADDED = 'OTHER_SCHEDULE_ASSIGNEES_ADDED',
    OTHER_SCHEDULE_ASSIGNEES_REMOVED = 'OTHER_SCHEDULE_ASSIGNEES_REMOVED',
    OTHER_SCHEDULE_REVIEWED = 'OTHER_SCHEDULE_REVIEWED',
    OTHER_SCHEDULE_AWAITING_REVIEW = 'OTHER_SCHEDULE_AWAITING_REVIEW',
    OTHER_SCHEDULE_ARCHIVED = 'OTHER_SCHEDULE_ARCHIVED',
    COMMENT_TAGGED = 'COMMENT_TAGGED',
    COMMENT_REPLIED = 'COMMENT_REPLIED',
    COMMENT_ACTIVE = 'COMMENT_ACTIVE',
    COMMENT_RESOLVED = 'COMMENT_RESOLVED',
    QUERY_REPLIED = 'QUERY_REPLIED',
    QUERY_ACTIVE = 'QUERY_ACTIVE',
    QUERY_RESOLVED = 'QUERY_RESOLVED',
    QUERY_TAGGED = 'QUERY_TAGGED',
    CERTIFICATION_PREPARER_REMOVED = 'CERTIFICATION_PREPARER_REMOVED',
    CERTIFICATION_REVIEWER_REMOVED = 'CERTIFICATION_REVIEWER_REMOVED',
    CERTIFICATION_APPROVER_REMOVED = 'CERTIFICATION_APPROVER_REMOVED',
    CERTIFICATION_PREPARER_STATUS_CHANGE = 'CERTIFICATION_PREPARER_STATUS_CHANGE',
    CERTIFICATION_REVIEWER_STATUS_CHANGE = 'CERTIFICATION_REVIEWER_STATUS_CHANGE',
    CERTIFICATION_APPROVER_STATUS_CHANGE = 'CERTIFICATION_APPROVER_STATUS_CHANGE',
    CERTIFICATION_PREPARER_DONE = 'CERTIFICATION_PREPARER_DONE',
    CERTIFICATION_REVIEWER_DONE = 'CERTIFICATION_REVIEWER_DONE',
    CERTIFICATION_APPROVER_DONE = 'CERTIFICATION_APPROVER_DONE',
    CERTIFICATION_PREPARER_READY = 'CERTIFICATION_PREPARER_READY',
    CERTIFICATION_REVIEWER_READY = 'CERTIFICATION_REVIEWER_READY',
    CERTIFICATION_APPROVER_READY = 'CERTIFICATION_APPROVER_READY',
}

export type UserNotification = {
    userId: string;
    batchId: string;
    notification: {
        id: string;
        firmId: string;
        message: string;
        type: NotificationType;
        workpaper?: { id: string; name: string } | null;
        entity?: { id: string; name: string } | null;
        destinationUrl?: string;
        createdAt: Date;
    };
    readAt: Date | null;
    dismissedAt: Date | null;
    relatedNotifications?: string[];
    isRead: boolean;
    isDismissed: boolean;
};
export type UserNotificationPreference = {
    userId: string;
    firmId: string;
    config: {
        [key: string]: { type: NotificationPreferenceType; enabled: boolean }[];
        workpaper: { type: NotificationPreferenceType; enabled: boolean }[];
        worksheet: { type: NotificationPreferenceType; enabled: boolean }[];
        otherSchedule: { type: NotificationPreferenceType; enabled: boolean }[];
        comment: { type: NotificationPreferenceType; enabled: boolean }[];
        query: { type: NotificationPreferenceType; enabled: boolean }[];
        certification: { type: NotificationPreferenceType; enabled: boolean }[];
    };
};
